import createAxiosInstance from "../util/axiosInstance";

const api = createAxiosInstance('/ingresos');

const fetchIngresos = () => api.get('/');
// actions/ingresoActions.js
const fetchIngreso = (nrorec) => api.get(`/by-recibo/${nrorec}`); // Cambiar la ruta
const createIngreso = (data) => api.post('/', data);
const updateIngreso = (id, data) => api.put(`/${id}`, data);
const deleteIngreso = (id) => api.delete(`/${id}`);
const fetchIngresosBySocio = (codreg) => api.get(`/by-socio/${codreg}`);

export default {
  fetchIngresos,
  fetchIngreso,
  createIngreso,
  updateIngreso,
  deleteIngreso,
  fetchIngresosBySocio
};